import Phaser from 'phaser'

export default class PauseMenu extends Phaser.Scene
{
    constructor()
    {
        super('pausemenu');
    }

    init()
    {
        //get user data
        //get user progress
    }


    create()
    {
        var self = this;

        //Add UI
        //this.pauseBackground = this.add.sprite(400, 780, 'bg',2);
        this.fade = this.add.rectangle(400, 800, 800, 1600, 0x000000, 0.5);
        this.pausePanel = this.add.sprite( 0, 0, 'ui','window-pause').setScale(0);
        Phaser.Display.Align.In.Center(this.pausePanel, this.fade);

        this.tweens.add({
          targets: this.pausePanel,
          scale: 1,
          duration: 200,
          delay: 0,
          onComplete:function(){
            self.initPanel();
          }
        });
    }

    initPanel()
    {
      let self = this;

      this.resumeButton = this.add.sprite( 0, 0, 'ui', 'button-resume');
      this.mainmenuButton = this.add.sprite( 0, 0, 'ui', 'button-exit');

      //Add button interactions
      this.resumeButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function () {
        self.resumeButton.setScale(1);
        self.sound.resumeAll();
        self.scene.stop();
        self.scene.resume('game');
      });
      this.resumeButton.on('pointerover',function(){
        self.resumeButton.setScale(1.2);
        self.mainmenuButton.setScale(0.8);
      });
      this.resumeButton.on('pointerout',function(){
        self.resumeButton.setScale(1);
        self.mainmenuButton.setScale(1);
      });
      this.mainmenuButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function () {
        self.mainmenuButton.setScale(1);
        self.sound.stopAll();
        self.scene.stop('game');
        self.scene.start('mainmenu');
      });
      this.mainmenuButton.on('pointerover',function(){
        self.mainmenuButton.setScale(1.2);
        self.resumeButton.setScale(0.8);
      });
      this.mainmenuButton.on('pointerout',function(){
        self.resumeButton.setScale(1);
        self.mainmenuButton.setScale(1);
      });

      //Align buttons
      Phaser.Display.Align.In.Center(this.resumeButton, this.pausePanel, 130, 180);
      Phaser.Display.Align.In.Center(this.mainmenuButton, this.pausePanel, -130, 180);
    }
}
